import React, { Fragment } from 'react';
import Homebg from '../../../svg_img/heroTop.svg'
import { Link } from 'react-router-dom';

function HomeSection() {
    return (
        <Fragment>
            <div className="xl:max-w-[1350px] 2xl:max-w-[1490px] 2xl:ml-[35px] mt-6 mx-auto px-4 grid grid-cols-1 lg:grid-cols-2 items-center">
                <div className="space-y-8 ml-[20px] lg:ml-0 mt-[100px] lg:mt-0 mb-[100px] lg:mb-0">
                    <h1 className="font-bold text-[#6F5DE0] text-3xl lg:text-5xl w-[650px]">We are One</h1>
                    <p className="xl:w-[510px] 2xl:w-[550px] text-[22px]">
                        Unacceptable help students visualize different curriculum topics, which are challenging to learn or visualize while having much fun, making it easy for students to learn and gain practical knowledge of its working. It is also a platform where students can discuss different topics in the chat room.
                    </p>
                    <Link to="/explore">
                        <button className="bg-[#6F5DE0] hover:bg-[#6F5DE0] text-white font-bold py-4 px-12 rounded">
                            Learn Now
                        </button>
                    </Link>
                </div>
                <div
                    className="sm:hidden lg:inline-block lg:w-[800px] lg:h-[750px]  justify-center bg-no-repeat xl:ml-[-40px] 2xl:ml-[-30px]"
                    style={{ backgroundImage: `url(${Homebg})` }}
                ></div>
            </div>
        </Fragment>
    );
}

export default HomeSection;
